import { useId } from "react";

export const Mark = ({ className = "w-8 h-8" }) => {
  const id = useId().replace(/:/g, "");
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
      <defs>
        <mask id={`m${id}`}>
          <rect width="32" height="32" fill="#fff" />
          <circle cx="14.6" cy="16" r="7.4" fill="#000" />
        </mask>
      </defs>
      <circle cx="11.5" cy="16" r="8.4" fill="currentColor" mask={`url(#m${id})`} />
      <circle cx="19.5" cy="16" r="7.2" fill="none" stroke="currentColor" strokeWidth="0.8" />
      <circle cx="20.5" cy="16" r="2.6" fill="currentColor" />
      <path
        d="M20.5 11.2v1.6M20.5 19.2v1.6M15.7 16h1.6M23.7 16h1.6M17.1 12.6l1.1 1.1M22.8 18.3l1.1 1.1M17.1 19.4l1.1-1.1M22.8 13.7l1.1-1.1"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const Sparkle = ({ className = "w-3 h-3" }) => (
  <svg viewBox="0 0 24 24" className={className} aria-hidden="true">
    <path d="M12 0c.6 6.6 5.4 11.4 12 12-6.6.6-11.4 5.4-12 12-.6-6.6-5.4-11.4-12-12C6.6 11.4 11.4 6.6 12 0z" fill="currentColor" />
  </svg>
);
